<script lang="ts">
	import MenuItem from "../atoms/MenuItem.svelte"
	import IconChevronRight from "../assets/IconChevronRight.svelte"
	import IconChevronDown from "../assets/IconChevronDown.svelte";
	import Divider from "../atoms/Divider.svelte";
	export let click: () => void = undefined
	export let divider: boolean = false
	let opened = false

	const toggle = () => {
		opened = !opened
	}
</script>

{#if divider}
	<Divider/>
{/if}

<MenuItem click={click || toggle} selected={opened}>
	<div class="w-full">
	  <div class="relative flex">
			<slot>
			</slot>
	    <div class="absolute accordion">
	  		{#if opened}
	       	<IconChevronDown/>
	  		{:else}
	       	<IconChevronRight/>
	  		{/if}
	    </div>
	  </div>
	</div>
</MenuItem>

{#if opened}
  <div>
  	<slot name="items">
  	</slot>
  </div>
{/if}

<style lang="postcss">
	.accordion {
		right: 0;
	}
</style>